(function () {
  function normalizedText(element) {
    return (element && element.textContent ? element.textContent : '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseMarker(element) {
    var text = normalizedText(element);
    var match = text.match(/^\[([a-z0-9_:-]+)\]$/i);
    if (!match) return null;

    var parts = match[1].toLowerCase().split(':');
    var base = parts.shift();
    var supported = /^(text|wide|full|products_[123]|single_photo_\d+|double_photo_\d+|slideshow_[123])$/;
    if (!supported.test(base)) return null;

    var marker = {
      base: base,
      width: null,
      frame: null
    };

    parts.forEach(function (option) {
      if (option === 'text' || option === 'wide' || option === 'full') {
        marker.width = option;
      }

      if (option === 'frame-left' || option === 'frame-right' || option === 'frame-both') {
        marker.frame = option;
      }
    });

    return marker;
  }

  function removeMarkerText(element, marker) {
    var target = '[' + marker + ']';
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var value = node.nodeValue || '';
      var index = value.toLowerCase().indexOf(target.toLowerCase());

      if (index !== -1) {
        node.nodeValue = value.slice(0, index) + value.slice(index + target.length);
        break;
      }
    }

    element.querySelectorAll('span, strong, em').forEach(function (inline) {
      if (normalizedText(inline) === '' && !inline.querySelector('img, picture, video, iframe')) {
        inline.remove();
      }
    });
  }

  function isImageOnly(element) {
    if (!element || element.matches('table')) return false;
    var image = element.matches('img') ? element : element.querySelector('img');
    if (!image) return false;

    var clone = element.cloneNode(true);
    clone.querySelectorAll('img, picture, source, br').forEach(function (node) {
      node.remove();
    });

    return normalizedText(clone) === '';
  }

  function isVideoBlock(element) {
    return !!(element && (element.matches('video, iframe') || element.querySelector('video, iframe')));
  }

  function enhanceImageTable(table) {
    var cells = Array.prototype.slice.call(table.querySelectorAll('td, th'));
    if (cells.length < 2) return false;

    var allImages = cells.every(function (cell) {
      return !!cell.querySelector('img') && normalizedText(cell) === '';
    });

    if (!allImages) return false;

    var firstRow = table.querySelector('tr');
    var columns = firstRow ? firstRow.querySelectorAll('td, th').length : 2;

    table.classList.add('editorial-image-grid', 'is-width-wide');
    table.style.setProperty('--image-columns', Math.max(columns, 2));
    return true;
  }

  function applyWidth(block, width) {
    if (!width) return;
    block.classList.remove('is-width-wide', 'is-width-full', 'is-width-text');
    block.classList.add('is-width-' + width);
  }

  function applyFrame(block, frame) {
    if (!frame || !block.classList.contains('editorial-inline-double')) return;

    block.classList.remove(
      'editorial-inline-double--frame-left',
      'editorial-inline-double--frame-right',
      'editorial-inline-double--frame-both'
    );
    block.classList.add('editorial-inline-double--has-frame');
    block.classList.add('editorial-inline-double--' + frame);
  }

  function replaceTemplateMarkers(body) {
    var templateRoot = body.closest('.editorial-article__content') || document;

    Array.prototype.slice.call(body.children).forEach(function (block) {
      var marker = parseMarker(block);
      if (!marker || marker.base === 'text' || marker.base === 'wide' || marker.base === 'full') return;

      var template = templateRoot.querySelector('template[data-editorial-template="' + marker.base + '"]');

      if (template && template.content.firstElementChild) {
        var replacement = template.content.firstElementChild.cloneNode(true);

        if (marker.width) {
          applyWidth(replacement, marker.width);
          replacement.dataset.editorialWidth = marker.width;
        }

        if (marker.frame) {
          applyFrame(replacement, marker.frame);
        }

        block.replaceWith(replacement);
      } else {
        block.remove();
      }
    });
  }

  function updateSlideshow(slideshow) {
    var track = slideshow.querySelector('[data-slideshow-track]');
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slideshow-slide]'));
    var dots = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slideshow-index]'));
    if (!track || slides.length === 0) return;

    var slideWidth = track.clientWidth || 1;
    var activeIndex = Math.round(track.scrollLeft / slideWidth);
    activeIndex = Math.max(0, Math.min(activeIndex, slides.length - 1));

    dots.forEach(function (dot, index) {
      var active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function goToSlideshowIndex(slideshow, index) {
    var track = slideshow.querySelector('[data-slideshow-track]');
    var slides = slideshow.querySelectorAll('[data-slideshow-slide]');
    if (!track || slides.length === 0) return;

    var targetIndex = Math.max(0, Math.min(index, slides.length - 1));
    track.scrollTo({ left: targetIndex * track.clientWidth, behavior: 'smooth' });
  }

  function initializeSlideshows(scope) {
    scope.querySelectorAll('[data-editorial-slideshow]').forEach(function (slideshow) {
      if (slideshow.dataset.slideshowInitialized === 'true') return;
      var track = slideshow.querySelector('[data-slideshow-track]');
      if (!track) return;

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateSlideshow(slideshow);
          ticking = false;
        });
      });

      slideshow.dataset.slideshowInitialized = 'true';
      updateSlideshow(slideshow);
    });
  }

  function enhanceContent(body) {
    if (!body || body.dataset.editorialProcessed === 'true') return;

    replaceTemplateMarkers(body);
    var pendingWidth = null;

    Array.prototype.slice.call(body.children).forEach(function (block) {
      var marker = parseMarker(block);
      var inlineWidth = null;
      var containsMedia = !!block.querySelector('img, picture, video, iframe, table');

      if (marker && (marker.base === 'full' || marker.base === 'wide' || marker.base === 'text')) {
        if (containsMedia) {
          inlineWidth = marker.base;
          removeMarkerText(block, marker.base);
        } else {
          pendingWidth = marker.base;
          block.remove();
          return;
        }
      }

      var enhanced = false;
      if (block.matches('table')) {
        enhanced = enhanceImageTable(block);
      } else if (isImageOnly(block)) {
        block.classList.add('editorial-inline-media', 'is-width-wide');
        enhanced = true;
      } else if (isVideoBlock(block)) {
        block.classList.add('editorial-inline-video', 'is-width-wide');
        enhanced = true;
      } else if (
        block.classList.contains('editorial-inline-carousel') ||
        block.classList.contains('editorial-inline-photo') ||
        block.classList.contains('editorial-inline-double') ||
        block.classList.contains('editorial-inline-slideshow')
      ) {
        enhanced = true;
      }

      if (enhanced) {
        var explicitWidth = block.dataset.editorialWidth || inlineWidth;
        applyWidth(block, explicitWidth || pendingWidth);
        pendingWidth = null;
      }
    });

    body.querySelectorAll('.NOAUDIO iframe').forEach(function (iframe) {
      if (iframe.src && iframe.src.indexOf('youtube.com') > -1 && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
      }
    });

    initializeSlideshows(body);
    body.dataset.editorialProcessed = 'true';
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-editorial-content]').forEach(enhanceContent);
  }

  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });

  document.addEventListener('click', function (event) {
    var carouselButton = event.target.closest('[data-carousel-direction]');
    if (carouselButton) {
      var carousel = carouselButton.closest('[data-editorial-carousel]');
      var carouselTrack = carousel && carousel.querySelector('[data-carousel-track]');
      if (!carouselTrack) return;
      var carouselDirection = carouselButton.getAttribute('data-carousel-direction') === 'next' ? 1 : -1;
      carouselTrack.scrollBy({ left: carouselDirection * carouselTrack.clientWidth * 0.82, behavior: 'smooth' });
      return;
    }

    var slideshowButton = event.target.closest('[data-slideshow-direction]');
    if (slideshowButton) {
      var slideshow = slideshowButton.closest('[data-editorial-slideshow]');
      var slideshowTrack = slideshow && slideshow.querySelector('[data-slideshow-track]');
      if (!slideshow || !slideshowTrack) return;
      var currentIndex = Math.round(slideshowTrack.scrollLeft / (slideshowTrack.clientWidth || 1));
      var slideshowDirection = slideshowButton.getAttribute('data-slideshow-direction') === 'next' ? 1 : -1;
      goToSlideshowIndex(slideshow, currentIndex + slideshowDirection);
      return;
    }

    var slideshowDot = event.target.closest('[data-slideshow-index]');
    if (slideshowDot) {
      var dotSlideshow = slideshowDot.closest('[data-editorial-slideshow]');
      if (!dotSlideshow) return;
      goToSlideshowIndex(dotSlideshow, parseInt(slideshowDot.getAttribute('data-slideshow-index'), 10) || 0);
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-editorial-slideshow]').forEach(updateSlideshow);
  });
})();